import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { SalaryListWrapper } from './SalaryPageStyled'
import { inject, observer } from 'mobx-react'
import SalaryListDepartment from './SalaryListDepartment'
import { Alert, Empty, Tabs } from 'antd'
import { blue } from '../../color'
import utils from '../../utils'
import SalaryManager from './SalaryManager'
import { Await, useParams } from 'react-router-dom'
import { SALARY_TYPE } from '../../constants'
import SpinnerInlineComponent from '../../components/LoadingSpinner/SpinnerInlineComponent'
import { EmptyText } from '../../components/common/CellText'
import styled from 'styled-components'

const { TabPane } = Tabs
const hidden = {
  visibility: 'hidden',
  height: 0,
  overflow: 'hidden',
}
const SalaryList = props => {
  const {
    proposalSalaryStore,
    isLoadingSalary,
    isShowSalaryInfo,
    isVisibleSalaryImportFileModal,
  } = props
  const { id: salaryCode } = useParams()
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  const { employeeSalaryData, managerSalaryData } = proposalSalaryStore
  const [salaryTabActive, setSalaryTabActive] = useState(SALARY_TYPE.EMPLOYEE)

  const onChangeSalaryTabs = tab => {
    setSalaryTabActive(tab)
  }
  const employeeSalaryList = useMemo(
    () => (
      <div>
        {employeeSalaryData.emp_departments?.map(item => (
          <SalaryListDepartment key={item.department_code} salaryItem={item} />
        ))}
      </div>
    ),
    [employeeSalaryData]
  )

  const salaryManagerList = useMemo(
    () => <SalaryManager managerSalaryData={managerSalaryData} />,
    [managerSalaryData]
  )
  return (
    <ResponsiveWrapper isShowSalaryInfo={isShowSalaryInfo}>
      {employeeSalaryData.emp_departments && (
        <Tabs activeKey={salaryTabActive} onChange={onChangeSalaryTabs}>
          <TabPane tab="Người lao động" key={SALARY_TYPE.EMPLOYEE} />
          <TabPane tab="Lương người quản lý" key={SALARY_TYPE.MANAGER} />
        </Tabs>
      )}
      <div>
        <div style={salaryTabActive === SALARY_TYPE.MANAGER ? hidden : {}}>
          {employeeSalaryList}
        </div>
        <div style={salaryTabActive === SALARY_TYPE.EMPLOYEE ? hidden : {}}>
          {salaryManagerList}
        </div>
      </div>
      {!isLoadingSalary &&
      (!employeeSalaryData.emp_departments ||
        !managerSalaryData.manager_salary_list) ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={`${
            salaryCode
              ? 'Không có dữ liệu'
              : 'Hãy nhập từ file bảng lương để xem dữ liệu!'
          }`}
        />
      ) : (
        <div
          style={{
            display: `${
              salaryTabActive === SALARY_TYPE.EMPLOYEE ? 'block' : 'none'
            }`,
          }}>
          {windowWidth <= 768 ? (
            <Alert
              message={
                <div className="salary-total">
                  <div className="salary-total-content-phone">
                    <span style={{ color: blue, width: '160px' }}>
                      Tổng ngày công thực tế:
                    </span>
                    <span>
                      {employeeSalaryData.tong_so_ngay_di_lam_thuc_te ? (
                        utils.formatCurrency(
                          employeeSalaryData.tong_so_ngay_di_lam_thuc_te
                        )
                      ) : (
                        <EmptyText>Không rõ</EmptyText>
                      )}
                    </span>
                  </div>
                  <div className="salary-total-content-phone">
                    <span style={{ color: blue, width: '160px' }}>
                      Tổng phụ cấp:
                    </span>
                    <span>
                      {employeeSalaryData.tong_phu_cap ? (
                        utils.formatCurrency(employeeSalaryData.tong_phu_cap)
                      ) : (
                        <EmptyText>Không rõ</EmptyText>
                      )}
                    </span>
                  </div>
                  <div className="salary-total-content-phone">
                    <span style={{ color: blue, width: '160px' }}>
                      Tổng khấu trừ:
                    </span>
                    <span>
                      {employeeSalaryData.tong_khau_tru ? (
                        utils.formatCurrency(employeeSalaryData.tong_khau_tru)
                      ) : (
                        <EmptyText>Không rõ</EmptyText>
                      )}
                    </span>
                  </div>
                  <div className="salary-total-content-phone">
                    <span style={{ color: blue, width: '160px' }}>
                      Tổng lương tháng:
                    </span>
                    <span>
                      {employeeSalaryData.tong_luong_thang ? (
                        utils.formatCurrency(
                          employeeSalaryData.tong_luong_thang
                        )
                      ) : (
                        <EmptyText>Không rõ</EmptyText>
                      )}
                    </span>
                  </div>
                </div>
              }
              type="success"
            />
          ) : (
            <Alert
              message={
                <div className={'salary-total'}>
                  <div
                    className={'salary-total-content'}
                    style={{ color: blue, marginBottom: 8 }}>
                    <div style={{ flex: '0 0 186px' }}>
                      Tổng ngày công thực tế
                    </div>
                    <div>Tổng phụ cấp</div>
                    <div>Tổng khấu trừ</div>
                    <div>Tổng lương tháng</div>
                  </div>
                  <div className={'salary-total-content'}>
                    <div style={{ flex: '0 0 180px' }}>
                      {employeeSalaryData.tong_so_ngay_di_lam_thuc_te ? (
                        utils.formatCurrency(
                          employeeSalaryData.tong_so_ngay_di_lam_thuc_te
                        )
                      ) : (
                        <EmptyText>Không rõ</EmptyText>
                      )}
                    </div>
                    <div>
                      {employeeSalaryData.tong_phu_cap ? (
                        utils.formatCurrency(employeeSalaryData.tong_phu_cap)
                      ) : (
                        <EmptyText>Không rõ</EmptyText>
                      )}
                    </div>
                    <div>
                      {employeeSalaryData.tong_khau_tru ? (
                        utils.formatCurrency(employeeSalaryData.tong_khau_tru)
                      ) : (
                        <EmptyText>Không rõ</EmptyText>
                      )}
                    </div>
                    <div>
                      {employeeSalaryData.tong_luong_thang ? (
                        utils.formatCurrency(
                          employeeSalaryData.tong_luong_thang
                        )
                      ) : (
                        <EmptyText>Không rõ</EmptyText>
                      )}
                    </div>
                  </div>
                </div>
              }
              type="success"
            />
          )}
        </div>
      )}
      <SpinnerInlineComponent noBackground isLoading={isLoadingSalary} />
    </ResponsiveWrapper>
  )
}

SalaryList.propTypes = {
  isLoadingSalary: PropTypes.bool,
}

const ResponsiveWrapper = styled(SalaryListWrapper)`
  /* Mobile styles */
  @media (max-width: 768px) {
    .salary-total-content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
    .ant-tabs-nav {
      flex-wrap: wrap;
    }
  }
  @media (max-width: 480px) {
    .salary-total-content {
      font-size: 0.85rem;
    }
    .ant-alert {
      padding: 12px;
    }
  }
  @media (max-width: 768px) {
  .salary-total .salary-total-content {
    display: flex;
    flex-direction: column; /* Stack items vertically */
    width: 100%;
    padding: 4px 0;
  }

  .salary-total-content-phone {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 4px 0;
  }

  .salary-total .salary-total-content-phone span:first-child {
    font-weight: bold;
    color: ${blue}; /* Label text in blue */
  }

  .salary-total .salary-total-content-phone span {
    text-align: left; /* Align all text to the left */
    font-size: 0.85rem;
  }

  /* Add padding or specific width to align values consistently */
  .salary-total .salary-total-content-phone span:last-child {
    padding-left: 20px; /* Adjust as needed for consistent left alignment */
    flex-grow: 1; /* Ensures consistent alignment */
  }
}

  }
`

export default inject('proposalSalaryStore')(observer(SalaryList))
